import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetResultByDivisionEngagementDomain = (state) =>
  state.get("widgetResultByDivisionEngagementV2", initialState)

export const makeSelectIsLoadingDivisions = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("isLoadingDivisions")
  )

export const makeSelectDivisionsDrillDown = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("divisionsDrillDown")
  )

export const makeSelectDimensions = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectMetric = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("metric")
  )

const makeSelectWidgetResultByDivisionEngagement = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDivisionEngagement
export { selectWidgetResultByDivisionEngagementDomain }
